export default __webpack_public_path__ + "static/media/06.5b025376.png";